import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderGroupGet } from '../../services';

export const fetchSliderGroupGet = createAsyncThunk(
    'sliderGroupGet/fetchSliderGroupGet',
    async ({ id }) => {
        const response = await SliderGroupGet(id)
        return response.result
    }
);

const sliderGroupGetSlice = createSlice({
    name: 'sliderGroupGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderGroupGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderGroupGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderGroupGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderGroupGetSlice.reducer;
